import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIssuuComponent } from './simple-icons-issuu.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIssuuComponent ],
    exports:      [ SimpleIconsIssuuComponent ],
    bootstrap:    []
})
export class SimpleIconsIssuuModule {}
